// extracted by mini-css-extract-plugin
export default {"days":"CalendarDays-days-bkUmr","day":"CalendarDays-day-t0Mh6","week":"CalendarDays-week-xFvOv","forecast":"CalendarDays-forecast-ICEGg","month":"CalendarDays-month-tpGR5"};